import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const links = [
  { href: "/#work", label: "Work" },
  { href: "/#studio", label: "Studio" },
  { href: "/#process", label: "Process" },
  { href: "/#estimator", label: "Estimator" },
  { href: "/journal", label: "Journal" },
  { href: "/#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-bone/90 backdrop-blur-md border-b border-sand" : "bg-transparent"
      }`}
    >
      <div className="w-full max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 flex items-center justify-between py-5">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 cursor-arrow">
          <span className="display text-[28px] leading-none">Virarc</span>
          <span className="hidden sm:inline label">— design. draft. build.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[13px] uppercase tracking-[0.2em] text-ink/80 hover:text-rust transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="/#contact"
          data-testid="nav-cta"
          className="hidden md:inline-flex items-center px-5 py-2.5 border border-ink text-[12px] uppercase tracking-[0.22em] hover:bg-ink hover:text-bone transition-colors"
        >
          Start a project →
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5"
        >
          <span className={`block w-6 h-px bg-ink transition-transform ${open ? "translate-y-[7px] rotate-45" : ""}`} />
          <span className={`block w-6 h-px bg-ink transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`block w-6 h-px bg-ink transition-transform ${open ? "-translate-y-[7px] -rotate-45" : ""}`} />
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-bone border-t border-sand">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-lg display text-ink"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
